// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"c29dc0da","126":"133444f1","192":"e7c679dc","303":"0e843030","359":"f4c9f82c","436":"7421e8c7","453":"59257a9a","757":"d8fb4c99"}[chunkId] + ".chunk.js";
};